var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "options-list" },
    _vm._l(_vm.groupedOptions, function(groupedOption, headerName) {
      return _c("div", { key: headerName, staticClass: "pt-4" }, [
        _c("h3", { staticClass: "mb-3" }, [
          _vm._v(
            "\n            " + _vm._s(_vm.toHeader(headerName)) + "\n        "
          )
        ]),
        _vm._v(" "),
        _vm.isColor(groupedOption)
          ? _c(
              "div",
              {
                staticClass:
                  "color-group justify-content-center justify-content-sm-start"
              },
              _vm._l(groupedOption, function(colorOption) {
                return _c("color-swatch", {
                  key: colorOption.chromeOptionCode,
                  attrs: {
                    color: _vm.mapColor(colorOption),
                    selected: _vm.isActive(colorOption)
                  },
                  on: { click: _vm.onSelect }
                })
              }),
              1
            )
          : _c(
              "div",
              { staticClass: "equipment-group" },
              _vm._l(groupedOption, function(option) {
                return _c("equipment-item", {
                  key: option.chromeOptionCode,
                  attrs: {
                    option: option,
                    "group-size": groupedOption.length,
                    active: _vm.isActive(option)
                  },
                  on: { select: _vm.onSelect }
                })
              }),
              1
            )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }